const devicePX = window.devicePixelRatio >= 3 ? '@3x' : '@2x'
const png = `${devicePX}.png`

const Cross_blue = require(`@/assets/myCard/Cross_blue${png}`)
const Cross_white = require(`@/assets/myCard/Cross_white${png}`)
const Help_Blue = require(`@/assets/myCard/Help_blue${png}`)
const Help_white = require(`@/assets/myCard/Help_white${png}`)
const Product_Blue = require(`@/assets/myCard/Product_Blue${png}`)
const More_Blue = require(`@/assets/myCard/More${png}`)
const Delete_Blue = require(`@/assets/myCard/delete${png}`)
const Rotate_Blue = require(`@/assets/myCard/rotate${png}`)
const Product_white = require(`@/assets/myCard/Product_white${png}`)
const LOGO_Blue = require(`@/assets/myCard/LOGO_Blue${png}`)
const LOGO_white = require(`@/assets/myCard/LOGO_white${png}`)
const Phone_White = require(`@/assets/myCard/Phone_White${png}`)
const Phone_Black = require(`@/assets/myCard/Phone_Black${png}`)
const Type_Blue = require(`@/assets/myCard/Type_Blue${png}`)
const Type_Vip = require(`@/assets/myCard/Type_Vip${png}`)
const LOGO_Double_Row_Blue = require(`@/assets/myCard/Logo_double_row_blue${png}`)
const Zoom_In = require(`@/assets/myCard/zoom_in${png}`)

export {
  Cross_blue,
  Cross_white,
  Help_Blue,
  Help_white,
  Product_Blue,
  More_Blue,
  Delete_Blue,
  Rotate_Blue,
  Product_white,
  LOGO_Blue,
  LOGO_white,
  Phone_White,
  Phone_Black,
  Type_Blue,
  Type_Vip,
  LOGO_Double_Row_Blue,
  Zoom_In
}
